import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import { func, object, string } from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { toSentenceCase } from "utils/string";

import classes from "./GenericDeleteModal.module.scss";

const GenericDeleteModal = ({
  extra = {},
  target = "the item",
  type = "item",
  onConfirmDelete = () => {},
}) => {
  const dispatch = useDispatch();

  const onClickConfirm = () => {
    dispatch(hideModal(modalTypes.GENERIC_DELETE_MODAL));
    onConfirmDelete(extra);
  };

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.GENERIC_DELETE_MODAL));
  };

  return (
    <Modal
      data-testid="generic-delete-modal"
      className="fade-in"
      show
      onDismiss={onDismiss}
      backdrop
      centered
    >
      <Modal.Header>Deleting {toSentenceCase(type, true)}</Modal.Header>

      <Modal.Body className={classes.body}>
        <p>
          Are you sure you wish to delete{" "}
          <span data-clarity-mask="True">{target}</span>?
        </p>
      </Modal.Body>

      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={onDismiss}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="save-button"
          variant={NewButtonVariant.l1}
          onClick={onClickConfirm}
        >
          Confirm Delete
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

GenericDeleteModal.propTypes = {
  extra: object,
  target: string,
  type: string,
  onConfirmDelete: func,
};

export default GenericDeleteModal;
